import React from 'react';
import type { FC } from 'react';

interface TagIconProps {
    className?: string;
}

export const TagIcon: FC<TagIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Tag Icon</title>
            <g clipPath="url(#clip0_4280_7082)">
                <path
                    d="M6 6.83333C6 7.05435 6.0878 7.26631 6.24408 7.42259C6.40036 7.57887 6.61232 7.66667 6.83333 7.66667C7.05435 7.66667 7.26631 7.57887 7.42259 7.42259C7.57887 7.26631 7.66667 7.05435 7.66667 6.83333C7.66667 6.61232 7.57887 6.40036 7.42259 6.24408C7.26631 6.0878 7.05435 6 6.83333 6C6.61232 6 6.40036 6.0878 6.24408 6.24408C6.0878 6.40036 6 6.61232 6 6.83333Z"
                    fill="white"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.5 5V9.31C2.50009 9.75199 2.67575 10.1758 2.98833 10.4883L9.41333 16.9133C9.78996 17.2899 10.3007 17.5015 10.8333 17.5015C11.3659 17.5015 11.8767 17.2899 12.2533 16.9133L16.9133 12.2533C17.2899 11.8767 17.5015 11.3659 17.5015 10.8333C17.5015 10.3007 17.2899 9.78996 16.9133 9.41333L10.4883 2.98833C10.1758 2.67575 9.75199 2.50009 9.31 2.5H5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4280_7082">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
